import graphql__79aa319fd264d7ff8019 from "./__generated__/AnswerSortableList_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import SortableListField from "../Form/Field/SortableListField";

const AnswerSortableList = props => {
  const { values, formField } = useFragment(AnswerSortableList_answer, props.answer);
  const {
    fieldName,
    label,
    required,
    hint,
    hintPosition,
    minimumSelectableOptions,
    maximumSelectableOptions,
    options,
    hide
  } = formField;
  const { parent } = props;

  return (
    <SortableListField
      fieldName={fieldName}
      label={label}
      required={required}
      hint={hint}
      hintPosition={hintPosition}
      minimumSelectableOptions={minimumSelectableOptions}
      maximumSelectableOptions={maximumSelectableOptions}
      options={options}
      hide={hide}
      parent={parent}
      defaultValues={values}
      defaultOptionsCount={options.length}
    />
  );
};

const AnswerSortableList_answer = graphql__79aa319fd264d7ff8019;

export default AnswerSortableList;
